import React from 'react'
import LinkButton from '../../atoms/LinkButton/LinkButton'
import * as S from './styled'
import { ReactComponent as DeleteIcon } from './delete-icon.svg'

type Props = {
  files: File[]
  hasUploaded: boolean
  setFiles: React.Dispatch<React.SetStateAction<File[]>>
  user: any
  setHasUploaded: React.Dispatch<React.SetStateAction<boolean>>
  uploadDocuments: () => void
}

function UploadCard({ files, setFiles, uploadDocuments }: Props) {
  const handleClick = async () => {
    uploadDocuments()
  }

  function removeItem(item: File) {
    setFiles(files.filter(file => file.name !== item.name))
  }

  return (
    <S.Card>
      <div>
        {files.map(file => (
          <S.Text1 key={file.name}>
            <strong>
              {file.name.length > 15 ? `${file.name.substring(0, 20)}...` : file.name}
            </strong>
            <span onClick={() => removeItem(file)}>
              {' '}
              <DeleteIcon style={{ cursor: 'pointer', position: 'relative', top: '3px' }} />
            </span>
          </S.Text1>
        ))}
      </div>

      <LinkButton handleClick={handleClick} text={'Ladda upp'} />
    </S.Card>
  )
}

export default UploadCard
